module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/H1-c8c3cdd706acb48c6378292f1d2ef1b4.svg";